import {AddProductToCartPayload, CartProduct} from "../types";

export function createAddProductToCartPayload(product: CartProduct, quantity: number | string): AddProductToCartPayload {
    if (product.offerItemId !== null) {
        return {product_id: product.id, quantity, offer_item_id: product.offerItemId};
    }

    return {product_id: product.id, quantity};
}
